<template lang="pug">
include Banner.pug
</template>

<script type="text/javascript">
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: "Banner",
  computed: mapState([
    "context", "token",
  ]),
  props: ["identifier"],
  data() {
    return {
      banner: null,
    }
  },
  async created() {
    const identifier = this.identifier
    const bannerResponse = await Api.banner(identifier, this.token)
    const banner = bannerResponse.data
    this.banner = banner
  },
  methods: {
    async registerAndGo(e) {
      const url = this.banner.url
      const identifier = this.identifier
      const token = this.token
      await Api.bannerClick(identifier, token)
    }
  }
}
</script>

<style scoped lang="scss">
.banner-row {
  display: block;
  width: 100%;
}

.banner-wrapper {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue